import { useEffect, useState } from 'react';
import { isMobileViewport } from '@/hooks/use-mobile.tsx';

/**
 * Tyle pikseli musi ubyć z widocznego obszaru, żeby uznać, że to klawiatura,
 * a nie chowający się pasek adresu Safari (ten zabiera kilkadziesiąt).
 */
const KEYBOARD_MIN_HEIGHT = 150;

const TEXT_FIELD_SELECTOR =
  'input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([inputmode="none"]), textarea';

const viewportShrunk = () => {
  const visual = window.visualViewport;
  if (!visual) return false;
  return window.innerHeight - visual.height > KEYBOARD_MIN_HEIGHT;
};

const textFieldFocused = () =>
  isMobileViewport() &&
  document.activeElement instanceof HTMLElement &&
  document.activeElement.matches(TEXT_FIELD_SELECTOR);

/**
 * Czy na ekranie jest klawiatura systemowa.
 *
 * Nie ma na to zdarzenia, więc składamy dwa sygnały: skurczony
 * `visualViewport` (iOS i Android, które nie zmieniają układu strony) oraz
 * kursor w polu tekstowym poniżej `md` (Android w trybie zmniejszającym
 * układ nie rusza `visualViewport`, a na iOS fokus wyprzedza przeliczenie
 * viewportu o kilkaset milisekund i bez niego stopka mrugałaby). Pola z
 * `inputmode="none"`, jak kontrolka selecta, klawiatury nie otwierają.
 */
export const useVirtualKeyboardOpen = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const update = () => setOpen(viewportShrunk() || textFieldFocused());
    const visual = window.visualViewport;

    visual?.addEventListener('resize', update);
    document.addEventListener('focusin', update);
    document.addEventListener('focusout', update);
    return () => {
      visual?.removeEventListener('resize', update);
      document.removeEventListener('focusin', update);
      document.removeEventListener('focusout', update);
    };
  }, []);

  return open;
};

export default useVirtualKeyboardOpen;
